import React, { memo, useEffect, useState } from "react";
import {
  RadioGroup,
  Box,
  Button,
  Radio,
  IconButton,
  Tooltip,
  Fade,
  Autocomplete,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  FormControlLabel,
  Checkbox,
  FormLabel,
  Typography,
  Select,
  Stack,
  InputAdornment,
} from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import TextField from "@mui/material/TextField";
import AddInvoiceItems from "./AddInvoiceItems";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { triggerLoader } from "../../../redux/reducers/LoaderTrigger";
import { useDispatch, useSelector } from "react-redux";
import AlertDialog from "../../AlertDialog/AlertDialog";
import CheckAndReturn from "../../../utility/CheckAndReturn";
import CardHeadMenu from "../CardHeadMenu/CardHeadMenu";
import OrderToInvoice from "../../../pages/Invoice/OrderToInvoice";
import Calculation from "../../../utility/Calculations";
import WantToPrint from "./WantToPrint";
import configServ from "../../../services/config";
import ConfirmationDialog from "../../Dialog/ConfirmationDialog";
import { rSetShowFab } from "../../../redux/reducers/GlobalVariables";
import CustomerDirectCashPopUp from "../../Customers/CustomerDirectCashPopUp";

//FUNCTION
function InvoiceCard({
  editData,
  setEditData,
  setIsChanged,
  isChanged,
  copyData,
  setCopyData,
}) {
  //#region code
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user_id, company_id, is_super, is_admin, permissions } = useSelector(
    (state) => state.GlobalVariables
  );
  const { company_type } = useSelector((state) => state.admin);
  const [invoiceData, setInvoiceData] = useState({});
  const [open, setOpen] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [oti, setOti] = useState(false);
  const [is_credit_limit, setIs_credit_limit] = useState(true);
  const [items, setItems] = useState([]);
  //const [firms, setFirms] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [autoGenerate, setAutoGenerate] = useState(true);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalTaxAmount, setTotalTaxAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [isInvoiceNumber, setIsInvoiceNumber] = useState(true);
  const [withGST, setWithGST] = useState(true); // default: true
  const [orderNo, setOrderNo] = useState([]);

  const [isManualCreated, setIsManualCreated] = useState(false);
  const [manualOrderNo, setManualOrderNo] = useState("");
  const [inputOrderNo, setInputOrderNo] = useState(""); // new state

  const [is_coupan, setIsCoupan] = useState(false);
  const [coupon_code, setCouponCode] = useState("");
  const [coupon_discount, setCouponDiscount] = useState(0);

  // ----- Invoice-against-Order flow (new, parallel to existing create flow) -----
  // Set when the user clicks the Search icon and an order is found.
  // While set, the Item dropdown is filtered to that order's item ids, and
  // handleSubmit routes to the new createInvoiceAgainstOrder endpoint.
  const [againstOrder, setAgainstOrder] = useState(null);
  const [isRowOrderSearchLocked, setIsRowOrderSearchLocked] = useState(false);

  const shipToAddressesInitial = [
    {
      id: "",
      address: "",
    },
  ];
  const [shipToAddresses, setShipToAddresses] = useState(
    shipToAddressesInitial
  );
  const invoiceInitial = {
    user_id: user_id,
    company_id: company_id,
    is_update: "",
    _token: "",
    contact_name: "",
    printID: "",
    buyeraddress: "",
    ShipToAddress: "",
    invhd1: "",
    invid: "",
    auto_gen: "on",
    invoice_number: "",
    date: Calculation.GetCurrentDate(),
    due_date: Calculation.getCurrentDatePlusDays(30),
    sales_order: "",
    salesperson: "",
    pay_mode: "",
    tcs: "",
    delivery_note: "",
    CgstVal: "",
    totalamtWithoutTcsTax: "",
    totaltaxwithoutTCS: "",
    customer_id: null,
    item: [
      {
        itemname: "",
        item_id: "",
        itemcode: "",
        packagingunit: "",
        hsn_code: "",
        tax_rate: "",
        qty: "",
        rate: "",
        amountWithoutTax: "",
        add_discount: "",
        tax_amount: "",
        amount: "",
        remarks: "",
        billable_rate: "",
        discount: "",
      },
    ],
  };
  const [invoice, setInvoice] = useState(invoiceInitial);
  const invoiceErrorInitial = {
    contact_name: "",
    buyeraddress: "",
    ShipToAddress: "",
    date: "",
    due_date: "",
  };

  const [inputValue, setInputValue] = useState(invoice.salesperson || "");

  // Filtered list of only "Staff" type
  const staffList = customers.filter((c) => c.type?.toLowerCase() === "staff");

  const [invoiceError, setInvoiceError] = useState(invoiceErrorInitial);
  const itemListInitial = [
    {
      id: 1,
      item_id: "",
      itemname: "",
      itemcode: "",
      packagingunit: "",
      hsn_code: "",
      tax_rate: "",
      qty: "",
      rate: "",
      amountWithoutTax: "",
      discount: 0,
      add_discount: 0,
      tax_amount: "",
      amount: "",
      remarks: "",
      rate_unit: "",
      billable_rate: "",
      discount: "",
    },
  ];
  const [itemList, setItemList] = useState(itemListInitial);
  const itemListErrorInitial = [
    {
      itemname: "",
      qty: "",
    },
  ];
  const [itemListError, setItemListError] = useState([]);
  const [isCreate, setIsCreate] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [title, setTitle] = useState("Alert");
  const [dialogContent, setDialogContent] = useState("");
  const [buttonType, setButtonType] = useState(null);
  const [openDirectCustomer, setOpenDirectCustomer] = useState(false);

  const location = useLocation();
  const [redirectOrderToInvoice, setRedirectOrderToInvoice] = useState(
    location.state?.orderToInvoice || null
  );

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    if (redirectOrderToInvoice) {
      console.log("redirectOrderToInvoice=", redirectOrderToInvoice);
      scrollToTop();
      setIsEdit(false);
      setIsCreate(true);
      setIsCoupan(redirectOrderToInvoice.is_coupon_applied === 1);
      setCouponCode(redirectOrderToInvoice.coupon_code || "");
      setCouponDiscount(redirectOrderToInvoice.coupon_discount || 0);

      const inv = {
        contact_name: redirectOrderToInvoice.partyname,
        printID: "",
        buyeraddress: redirectOrderToInvoice.billtoaddress,
        ShipToAddress: redirectOrderToInvoice.shiptoaddress,
        auto_gen: "on",
        invoice_number: "",
        date: Calculation.GetCurrentDate(),
        due_date: Calculation.getCurrentDatePlusDays(30),
        order_id: redirectOrderToInvoice.id,
        sales_order:
          redirectOrderToInvoice.po_number || redirectOrderToInvoice.order_no,
        salesperson: redirectOrderToInvoice.salesperson,
        pay_mode: "",
        customer_id: redirectOrderToInvoice.customer_id,
      };
      setInvoice(inv);
      const itemlist = redirectOrderToInvoice.items.map((item, index) => ({
        id: index + 1,
        itemname: item.itemname,
        item_id: item.itemid,
        itemcode: item.item_code,
        packagingunit: "",
        hsn_code: item.hsn_code,
        tax_rate: withGST ? item.Taxrate : 0,
        qty: item.qty,
        unit: item.unit,
        rate: item.rate,
        amountWithoutTax: item.amount - item.tax_amount,
        discount: item.discount,
        tax_amount: item.tax_amount,
        amount: item.amount,
        remarks: "",
        billable_rate: "",
      }));
      setItemList(itemlist);
      fetchShipToAddress(redirectOrderToInvoice.customer_id);
      setInputOrderNo(
        redirectOrderToInvoice.po_number || redirectOrderToInvoice.order_no || ""
      );
    } else {
      setRedirectOrderToInvoice(null);
    }
  }, [redirectOrderToInvoice]);

  const handleOpenDialog = (heading, content, type) => {
    setTitle(heading);
    setDialogContent(content);
    setButtonType(type);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setTitle("Alert");
    setDialogContent("");
    setButtonType(null);
  };

  useEffect(() => {
    if (isCreate) {
      fetchCustomerList();
      fetchItemList();
    }
  }, [isCreate]);

  useEffect(() => {
    calculateTotalQuantity();
    calculateTotalTaxAmount();
    calculateTotalAmount();
  }, [itemList]);

  useEffect(() => {
    if (Object.keys(editData).length !== 0) {
      setInvoice(editData);

      const updatedItemList = editData.items.map((item) => {
        const matchedItem = items.find((x) => x.id === item.item_id);

        return {
          ...item,
          isTaxInclusive: matchedItem?.isTaxInclusive ?? false,
          discount: matchedItem?.discount ?? 0,
          add_discount: item.discount ?? 0,
          billable_rate: item.billable_rate ?? 0,
          rate: item.rate ?? 0,
          unit: item.unit || matchedItem?.unit || "",
        };
      });

      setItemList(updatedItemList);

      setIsEdit(true);
      setIsCreate(true);
      fetchShipToAddress(editData.customer_id, true);
      setWithGST(true);
      setIsManualCreated(editData.isManualCreated);
      setManualOrderNo(editData.manualOrderNo);
      setInputOrderNo(editData.sales_order || "");
    }
  }, [editData]);

  useEffect(() => {
    if (Object.keys(copyData).length !== 0) {
      // Use spread operator to selectively update fields
      const updatedInvoice = {
        ...copyData,
        invoice_number: "", // Keep this field empty
        date: Calculation.GetCurrentDate(), // Override with a specific value
        due_date: Calculation.getCurrentDatePlusDays(30),
        // Add other fields to keep unchanged or default here if needed
      };

      setInvoice(updatedInvoice);

      const updatedItemList = CheckAndReturn.UpdateItemList(copyData.items);
      setItemList(updatedItemList);

      setIsEdit(false);
      setIsCreate(true);
    }
  }, [copyData]);

  const fetchCustomerList = async () => {
    try {
      const result = await configServ.get_customer({
        company_id: company_id,
      });

      setCustomers(result);
    } catch (e) {
      console.log(e);
    }
  };

  const fetchItemList = async () => {
    try {
      const dataToSend = {
        company_id: company_id,
        search_by: null,
        search: null,
        per_page: null,
        page: null,
      };
      const res = await configServ.getItemListOnlyBomType(dataToSend);
      if (res.status === 200) {
        if (res.data.length > 0) {
          const result = res.data.filter((x) => x.item_type !== 3); //.filter((x) => x.status === 1);
          setItems(result);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const fetchShipToAddress = async (cust_id, edit = false) => {
    try {
      if (cust_id !== undefined && cust_id !== null) {
        let result = [];
        try {
          result = await configServ.getShipToAddress({ cust_id: cust_id });
        } catch (ex) {
          console.log(ex);
        }

        if (result.length > 0) {
          setShipToAddresses(result);
          if (result[0].address !== undefined && result[0].address !== null) {
            if (edit == false) {
              setInvoice((prev) => ({
                ...prev,
                ShipToAddress: result[0].address,
              }));
            }
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (invoice.contact_name) {
      const selectedCustomer = customers.find(
        (item) =>
          item.fname.toLowerCase() === invoice.contact_name.toLowerCase()
      );
      if (selectedCustomer !== undefined && !isEdit) {
        const fetchAndSetShipToAddress = async () => {
          await fetchShipToAddress(selectedCustomer.id);
        };
        fetchAndSetShipToAddress();
      }
    }
  }, [invoice.contact_name]);

  // Function to add a new item to the list
  // Function to add a new item to the list right after the current item
  const handleAddItem = (currentItemId) => {
    try {
      setItemList((prevList) => {
        // Check if the list is empty
        if (prevList.length === 0) {
          // Return the list with the first item if it's empty
          return [
            {
              id: 1,
              name: "",
              qty: "",
            },
          ];
        }

        // Find the index of the current item
        const currentIndex = prevList.findIndex(
          (item) => item.id === currentItemId
        );

        // Handle case when currentItemId is not found
        if (currentIndex === -1) {
          return prevList; // Return the original list without changes
        }

        // Create new item
        const newItem = {
          id: Math.max(...prevList.map((item) => item.id)) + 1, // New ID
          name: "",
          qty: "",
        };

        // Insert new item right after the current item
        return [
          ...prevList.slice(0, currentIndex + 1), // Items before and including the current item
          newItem, // New item to be added
          ...prevList.slice(currentIndex + 1), // Items after the current item
        ];
      });
    } catch (e) {
      console.log(e);
    }
  };

  // Function to delete an item from the list based on its ID
  const handleDeleteItem = (data) => {
    try {
      // Check if the data object is valid
      if (data !== null && data !== undefined) {
        const id = data.id;

        setItemList((prevList) => {
          // If there's more than one item, remove the selected one
          if (prevList.length > 1) {
            return prevList.filter((item) => item.id !== id);
          }

          // If only one item is left, reset to the initial state
          else if (prevList.length === 1) {
            return itemListInitial; // Assuming `itemListInitial` is your default list
          }

          return prevList; // Return the same list if no changes
        });
      } else {
        console.log("Invalid data object passed to handleDeleteItem.");
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleInputChange = (event, id) => {
    try {
      const { name, value } = event.target;
      let updatedItem;
      if (value !== null && value !== undefined) {
        if (value.length > 0) {
          if (name === "itemname") {
            // Find the selected item from the options
            const selectedItem = items.find(
              (item) =>
                `${item.item_name.toLowerCase()}(${item.item_code.toLowerCase()})${
                  item.unit ? `-${item.unit.toLowerCase()}` : ""
                }` === value.toLowerCase()
            );
            // If a valid item is selected, update the item properties accordingly
            if (selectedItem) {
              updatedItem = {
                ...itemList.find((item) => item.id === id),
                item_id: selectedItem.id,
                itemname: selectedItem.item_name,
                itemcode: selectedItem.item_code,
                packagingunit: selectedItem.packagingunit,
                hsn_code: selectedItem.hsncode,
                add_discount: 0,
                qty: "",
                unit: selectedItem.unit,
                rate: selectedItem.rate_unit,
                tax_rate: withGST ? selectedItem.tax_rate : 0,
                issizeAdded: Boolean(selectedItem.issizeAdded),
                // size_id:selectedItem.size_id || null,
                tax_amount: "0",
                amount: "0",
                billable_rate: selectedItem.billable_rate || "",
                isTaxInclusive: selectedItem.isTaxInclusive,
                discount: selectedItem.discount,
              };
            } else {
              // If the selected item is not found, reset the properties
              updatedItem = {
                ...itemList.find((item) => item.id === id),
                item_id: "",
                itemname: "",
                itemcode: "",
                packagingunit: "",
                hsn_code: "",
                add_discount: "",
                rate: "",
                tax_rate: "",
                billable_rate: "",
              };
            }
          } else {
            // For other fields, just update the value
            updatedItem = {
              ...itemList.find((item) => item.id === id),
              [name]: value,
            };
          }
          // Update the itemList state with the updated item
          const updatedItemList = itemList.map((item) =>
            item.id === id ? updatedItem : item
          );
          setItemList(updatedItemList);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleQuantityChange = (event, id) => {
    try {
      const { name, value } = event.target;
      let updatedItem;
      if (value !== null && value !== undefined) {
        // Find the selected item from the options
        const selectedItem = itemList.find((item) => item.id === id);
        if (value.toString().length > 0) {
          if (name === "qty") {
            // If a valid item is selected, update the item properties accordingly
            if (selectedItem) {
              const taxAmount = CheckAndReturn.roundToInteger(
                Calculation.GetDiscountTaxAmount(
                  withGST ? selectedItem.tax_rate : 0,
                  selectedItem.billable_rate,
                  value,
                  selectedItem.add_discount
                )
              );
              const amountWithoutTax = CheckAndReturn.roundToInteger(
                Calculation.GetAmount(selectedItem.billable_rate, value)
              );
              const totalAmount = CheckAndReturn.roundToInteger(
                Calculation.GetDiscountTotalAmount(
                  withGST ? selectedItem.tax_rate : 0,
                  selectedItem.billable_rate,
                  value,
                  selectedItem.add_discount
                )
              );
              updatedItem = {
                ...itemList.find((item) => item.id === id),
                qty: value,
                amountWithoutTax: amountWithoutTax.toString(),
                tax_amount: taxAmount.toString(),
                amount: CheckAndReturn.roundToInteger(
                  totalAmount ?? 0
                ).toString(),
              };
            } else {
              // If the selected item is not found, reset the properties
              updatedItem = {
                ...itemList.find((item) => item.id === id),
                qty: "",
                amountWithoutTax: "0",
                tax_amount: "0",
                amount: "0",
              };
            }
          } else if (name === "billable_rate") {
            // If a valid item is selected, update the item properties accordingly
            if (selectedItem) {
              const taxAmount = CheckAndReturn.roundToInteger(
                Calculation.GetDiscountTaxAmount(
                  withGST ? selectedItem.tax_rate : 0,
                  value,
                  selectedItem.qty,
                  selectedItem.add_discount
                )
              );
              const amountWithoutTax = CheckAndReturn.roundToInteger(
                Calculation.GetAmount(value, selectedItem.qty)
              );
              const totalAmount = CheckAndReturn.roundToInteger(
                Calculation.GetDiscountTotalAmount(
                  withGST ? selectedItem.tax_rate : 0,
                  value,
                  selectedItem.qty,
                  selectedItem.discount
                )
              );
              updatedItem = {
                ...itemList.find((item) => item.id === id),
                billable_rate: value,
                amountWithoutTax: amountWithoutTax.toString(),
                tax_amount: taxAmount.toString(),
                amount: CheckAndReturn.roundToInteger(
                  totalAmount ?? 0
                ).toString(),
              };
            } else {
              // If the selected item is not found, reset the properties
              updatedItem = {
                ...itemList.find((item) => item.id === id),
                billable_rate: "",
                amountWithoutTax: "0",
                tax_amount: "0",
                amount: "0",
              };
            }
          } else {
            // For other fields, just update the value
            updatedItem = {
              ...itemList.find((item) => item.id === id),
              [name]: value,
            };
          }
          // Update the itemList state with the updated item
          const updatedItemList = itemList.map((item) =>
            item.id === id ? updatedItem : item
          );
          setItemList(updatedItemList);
        } else {
          if (name === "qty") {
            updatedItem = {
              ...itemList.find((item) => item.id === id),
              qty: "",
              tax_amount: "0",
              amount: "0",
            };
            const updatedItemList = itemList.map((item) =>
              item.id === id ? updatedItem : item
            );
            setItemList(updatedItemList);
          } else if (name === "billable_rate") {
            updatedItem = {
              ...itemList.find((item) => item.id === id),
              billable_rate: "",
              tax_amount: "0",
              amount: "0",
            };
            const updatedItemList = itemList.map((item) =>
              item.id === id ? updatedItem : item
            );
            setItemList(updatedItemList);
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleDiscountChange = (event, id) => {
    try {
      const { name, value } = event.target;
      let updatedItem;
      if (value !== null && value !== undefined) {
        // Find the selected item from the options
        const selectedItem = itemList.find((item) => item.id === id);
        if (value.length > 0) {
          if (name === "add_discount") {
            // If a valid item is selected, update the item properties accordingly
            if (selectedItem) {
              const taxAmount = CheckAndReturn.roundToInteger(
                Calculation.GetDiscountTaxAmount(
                  withGST ? selectedItem.tax_rate : 0,
                  selectedItem.billable_rate,
                  selectedItem.qty,
                  value
                )
              );
              const totalAmount = CheckAndReturn.roundToInteger(
                Calculation.GetDiscountTotalAmount(
                  withGST ? selectedItem.tax_rate : 0,
                  selectedItem.billable_rate,
                  selectedItem.qty,
                  value
                )
              );
              updatedItem = {
                ...itemList.find((item) => item.id === id),
                add_discount: value,
                tax_amount: taxAmount.toString(),
                amount: CheckAndReturn.roundToInteger(
                  totalAmount ?? 0
                ).toString(),
              };
            } else {
              // If the selected item is not found, reset the properties
              updatedItem = {
                ...itemList.find((item) => item.id === id),
                add_discount: "",
              };
            }
          } else {
            // For other fields, just update the value
            updatedItem = {
              ...itemList.find((item) => item.id === id),
              [name]: value,
            };
          }
          // Update the itemList state with the updated item
          const updatedItemList = itemList.map((item) =>
            item.id === id ? updatedItem : item
          );
          setItemList(updatedItemList);
        } else {
          updatedItem = {
            ...itemList.find((item) => item.id === id),
            [name]: value,
            tax_amount: CheckAndReturn.roundToInteger(
              Calculation.GetDiscountTaxAmount(
                withGST ? selectedItem.tax_rate : 0,
                selectedItem.billable_rate,
                selectedItem.qty,
                value
              )
            ),
            amount: CheckAndReturn.roundToInteger(
              Calculation.GetDiscountTotalAmount(
                withGST ? selectedItem.tax_rate : 0,
                selectedItem.billable_rate,
                selectedItem.qty,
                value
              )
            ),
          };
          const updatedItemList = itemList.map((item) =>
            item.id === id ? updatedItem : item
          );
          setItemList(updatedItemList);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleRemarksChange = (event, id) => {
    try {
      const { name, value } = event.target;
      let updatedItem;
      if (value !== null && value !== undefined) {
        // Find the selected item from the options
        const selectedItem = itemList.find((item) => item.id === id);
        if (value) {
          if (name === "remarks") {
            // If a valid item is selected, update the item properties accordingly
            if (selectedItem) {
              updatedItem = {
                ...itemList.find((item) => item.id === id),
                remarks: value,
              };
            } else {
              // If the selected item is not found, reset the properties
              updatedItem = {
                ...itemList.find((item) => item.id === id),
                remarks: "",
              };
            }
          } else {
            // For other fields, just update the value
            updatedItem = {
              ...itemList.find((item) => item.id === id),
              [name]: value,
            };
          }
          // Update the itemList state with the updated item
          const updatedItemList = itemList.map((item) =>
            item.id === id ? updatedItem : item
          );
          setItemList(updatedItemList);
        } else {
          updatedItem = {
            ...itemList.find((item) => item.id === id),
            [name]: value,
          };
          const updatedItemList = itemList.map((item) =>
            item.id === id ? updatedItem : item
          );
          setItemList(updatedItemList);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleCustomerInputChange = (event) => {
    try {
      const customerId = event.target.value;
      const selectedCustomer = customers.find((item) => item.id === customerId);
      if (selectedCustomer !== null && selectedCustomer !== undefined) {
        setInvoice((prev) => ({
          ...prev, // Copy existing fields
          customer_id: selectedCustomer.id, // Update the specific field with the new value
          contact_name: selectedCustomer.fname,
          buyeraddress: selectedCustomer.address,
          date: isEdit ? invoice.date : Calculation.GetCurrentDate(),
          due_date: isEdit
            ? invoice.due_date
            : Calculation.getCurrentDatePlusDays(
                selectedCustomer.credit_period ?? 30
              ),
          salesperson: selectedCustomer.salesperson,
          
        }));
        fetchShipToAddress(selectedCustomer.id);
        setItemList(itemListInitial);
        setInputOrderNo("");
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleInvoiceCustomer = (event) => {
    try {
      const { name, value } = event.target;

      //Update form
      setInvoice((prev) => ({
        ...prev, //copy existing field values
        [name]: value, //update field value
      }));
      if (name === "date") {
        const selectedCustomer = customers.find(
          (item) => item.id === invoice.customer_id
        );
        const dueDate = Calculation.addDays(
          value,
          selectedCustomer ? selectedCustomer.credit_period : 30
        );
        setInvoice((prev) => ({
          ...prev,
          due_date: dueDate,
        }));
      }
      // if (name === "ShipToAddress") {
      //   compareStateCodes(value);
      // }

      // Reset the validation error when the user starts typing
      if (invoiceError[name]) {
        setInvoiceError((prevValidationError) => ({
          ...prevValidationError,
          [name]: "",
        }));
      }
    } catch (e) {
      console.log(e);
    }
  };

  const compareStateCodes = async () => {
    try {
      dispatch(triggerLoader());
      const dataToSend = {
        cust_id: invoice.customer_id,
        address: invoice.ShipToAddress,
      };
      const state = await configServ.getStateByCidAddress(dataToSend);
      const company = await configServ.company_details({
        company_id: company_id,
      });
      if (state.State && company.State) {
        if (
          Boolean(state.State.toLowerCase() === company.State.toLowerCase())
        ) {
          setInvoice((state) => ({
            ...state,
            tax_type: "CGST+SGST",
          }));
        } else {
          setInvoice((state) => ({
            ...state,
            tax_type: "IGST",
          }));
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      dispatch(triggerLoader());
    }
  };

  // Handle the Autocomplete's onChange event
  // Updated handleAutocompleteChange to support keyboard navigation
  const handleAutocompleteChange = (event, value, id) => {
    if (value !== null && value !== undefined) {
      // Trigger the input change only when a valid value is selected
      handleInputChange({ target: { name: "itemname", value } }, id);
    }
  };

  const handleCustomerAutocompleteChange = (customer_name, value) => {
    try {
      if (value !== null && value !== undefined) {
        handleCustomerInputChange({
          target: { name: customer_name, value },
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  // Function to validate the invoice fields
  const validateInvoice = () => {
    const errors = {};

    // Check if the required fields are empty
    if (!invoice.customer_id) {
      errors.customer_id = "Customer Name is required.";
    }
    if (!invoice.buyeraddress) {
      errors.buyeraddress = "Bill To Address is required.";
    }
    if (!invoice.ShipToAddress || invoice.ShipToAddress === "") {
      errors.ShipToAddress = "ShipTo Address is required.";
    }
    if (!isInvoiceNumber && !isEdit) {
      errors.invoice_number = "required";
    }
    if (!invoice.date) {
      errors.date = "Invoice Date is required.";
    }
    if (!invoice.due_date) {
      errors.due_date = "Invoice Due Date is required.";
    }

    setInvoiceError(errors);
    return errors;
  };

  // Validate ItemList
  const validateItemList = () => {
    const errors = itemList.map((item) => {
      if (!item.issizeAdded) {
        return {
          itemname: !item.itemname ? "Item Name is required." : "",
          qty: !item.qty ? "Quantity is required." : "",
          // Add additional validations for other item fields as needed...
        };
      } else {
        return {
          itemname: !item.itemname ? "Item Name is required." : "",
          qty: !item.qty ? "Quantity is required." : "",
          size_id: !item.size_id ? "Size is required." : "",
          // Add additional validations for other item fields as needed...
        };
      }
    });

    setItemListError(errors);
    const hasErrors = errors.some((error) => error.itemname || error.qty);
    return hasErrors ? errors : {};
  };

  const handleSubmit = async () => {
    // Route to the against-order flow when an order is linked. Existing
    // unrestricted-create logic below is untouched for all other invocations.
    if (againstOrder?.order_id) {
      return handleSubmitAgainstOrder();
    }
    try {
      dispatch(triggerLoader());
      const invoiceErrors = validateInvoice();
      const itemListErrors = validateItemList();
      if (
        Object.keys(invoiceErrors).length > 0 ||
        Object.keys(itemListErrors).length > 0
      ) {
        // Handle the errors as needed (e.g., show error messages, prevent saving, etc.)
        return false; // Return early if there are errors
      }

      invoice.is_credit_limit = is_credit_limit;
      invoice.item = await handleInvoiceItemList();

      const dataToSend = {
        ...invoice,
        user_id: user_id,
        company_id: company_id,
        with_gst: withGST,
        isManualCreated: isManualCreated,
        manual_order_no: isManualCreated ? manualOrderNo : null,
      };

      if (!isEdit) {
        const res = await configServ.createInvoice(dataToSend);
        if (res.status === 200) {
          handleReset();
          setOpen(true);
          const resData = res.data;
          const printInvData = {
            ...resData,
            user_id: user_id,
          };
          setInvoiceData(printInvData);
          setIsCreate(!isCreate);
          setIsChanged(!isChanged);
        } else if (res.status === 409) {
          setConfirmationMessage(res.message);
        } else {
          handleOpenDialog(
            "Error",
            "Invoice creation failed. Please try again.",
            "error"
          );
        }
      } else {
        const res = await configServ.editInvoice(dataToSend);
        if (res.status === 200) {
          handleReset();
          setOpen(true);
          const resData = res.data;
          const printInvData = {
            ...resData,
            user_id: user_id,
          };
          setInvoiceData(printInvData);
          setIsCreate(!isCreate);
          setIsChanged(!isChanged);
        } else {
          handleOpenDialog(
            "Error",
            "Invoice updation failed. Please try again.",
            "error"
          );
        }
      }
    } catch (e) {
      console.log(e);
      handleOpenDialog("Error", "An unexpected error has occurred.", "error");
    } finally {
      dispatch(triggerLoader());
    }
  };

  const handleInvoiceItemList = async () => {
    try {
      const invoiceItems = itemList.map((item) => ({
        itemname: item.itemname,
        item_id: item.item_id,
        itemcode: item.itemcode,
        packagingunit: item.packagingunit,
        hsn_code: item.hsn_code,
        tax_rate: withGST ? item.tax_rate : 0,
        qty: item.qty,
        rate: item.rate,
        discount: item.add_discount,
        tax_amount: item.tax_amount,
        amount: item.amount,
        size_id: item.size_id,
        issizeAdded: item.issizeAdded,
        remarks: item.remarks,
        billable_rate: item.billable_rate,
      }));
      return invoiceItems;
    } catch (e) {
      console.log(e);
    }
  };

  const calculateTotalQuantity = () => {
    let totalQty = 0;
    itemList.forEach((item) => {
      // Parse the amount string to a float value
      const quantity = parseInt(item.qty);
      // Check if the amount is a valid number
      if (!isNaN(quantity)) {
        // Add the amount to the total
        totalQty += quantity;
      }
    });
    setTotalQuantity(totalQty);
  };

  const calculateTotalTaxAmount = () => {
    let totalTaxAmount = 0;
    itemList.forEach((item) => {
      // Parse the amount string to a float value
      const taxAmount = parseFloat(item.tax_amount);
      // Check if the amount is a valid number
      if (!isNaN(taxAmount)) {
        // Add the amount to the total
        totalTaxAmount += taxAmount;
      }
    });
    setTotalTaxAmount(totalTaxAmount.toFixed(2));
  };

  const calculateTotalAmount = () => {
    let totalAmount = 0;

    itemList.forEach((item) => {
      const amount = parseFloat(item.amount);
      if (!isNaN(amount)) {
        totalAmount += amount;
      }
    });

    if (is_coupan && coupon_discount) {
      totalAmount -= parseFloat(coupon_discount) || 0;
    }

    setTotalAmount(totalAmount.toFixed(2));
  };

  // Function to reset all form fields and state
  const handleReset = () => {
    setAutoGenerate(true);
    setTotalTaxAmount(0);
    setTotalAmount(0);
    setInvoice(invoiceInitial);
    setInvoiceError(invoiceErrorInitial);
    setItemList(itemListInitial);
    setItemListError([]);
    setEditData({});
    setIsEdit(false);
    setIs_credit_limit(true);
    setWithGST(true);
    setIsManualCreated(false);
    setManualOrderNo("");
    setAgainstOrder(null);
    setIsRowOrderSearchLocked(false);
    setInputOrderNo("");
  };

  // useEffect(() => {
  //   if (invoice.ShipToAddress) {
  //     const fetchAndSetGST = async () => {
  //       await compareStateCodes();
  //     };
  //     fetchAndSetGST();
  //   }
  // }, [invoice.ShipToAddress]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (invoice.ShipToAddress && !invoice.manualShipAddress) {
        compareStateCodes();
      }
    }, 500); // 0.5s delay
  
    return () => clearTimeout(handler);
  }, [invoice.ShipToAddress, invoice.manualShipAddress]);
  
  

  const hasOrderPoNumber = (order) => {
    const po = order?.po_number;
    return po != null && String(po).trim() !== "";
  };

  const getMissingPoNumberMessage = (order) =>
    `Please update the PO number of order ${
      order?.order_no || "#" + order?.id
    } first before continuing.`;

  const handleOTI = () => {
    setOti(!oti);
  };

  // ----- New: search for the latest order containing the currently-picked item
  // for the selected customer, then auto-fill invoice header fields. Does NOT
  // touch itemList. Once successful, sets `againstOrder` so the items dropdown
  // is filtered and submit routes to the new endpoint.
  const handleSearchAgainstOrder = async () => {
    try {
      const customer_id = invoice.customer_id;
      const itemid = itemList[0]?.item_id;
      if (!customer_id) {
        handleOpenDialog("Warning", "Please select a firm first.", "warning");
        return;
      }
      if (!itemid) {
        handleOpenDialog(
          "Warning",
          "Please pick an item in the row first.",
          "warning"
        );
        return;
      }
      dispatch(triggerLoader());
      const res = await configServ.getLatestOrderByItemCustomer({
        customer_id,
        itemid,
      });
      if (res.status === 200 && res.data) {
        const order = res.data;
        // Fill invoice header fields (NOT itemList) — merge into existing invoice
        setInvoice((prev) => ({
          ...prev,
          contact_name: order.partyname || prev.contact_name,
          buyeraddress: order.billtoaddress || prev.buyeraddress,
          ShipToAddress: order.shiptoaddress || prev.ShipToAddress,
          salesperson: order.salesperson || prev.salesperson,
          customer_id: order.customer_id || prev.customer_id,
          sales_order: order.order_no || prev.sales_order,
          order_id: order.id,
        }));
        // Track the order link so the items dropdown filters + submit routes
        setAgainstOrder({
          order_id: order.id,
          order_no: order.order_no,
          allowed_item_ids: (order.order_items || []).map((oi) => oi.itemid),
        });
        handleOpenDialog(
          "Success",
          `Linked to order ${order.order_no || "#" + order.id}.`,
          "success"
        );
      } else if (res.status === 404) {
        handleOpenDialog(
          "Info",
          res.message || "No matching order found.",
          "info"
        );
      } else if (res.status === 422) {
        handleOpenDialog(
          "Warning",
          res.message || "Validation failed.",
          "warning"
        );
      } else {
        handleOpenDialog(
          "Error",
          res.message || "Failed to load order.",
          "error"
        );
      }
    } catch (e) {
      console.log(e);
      var error = e?.response?.data;
      debugger
      if (error?.status === 404) {
        handleOpenDialog("Not Found", "Order not found.", "warning");
      } else {
        handleOpenDialog("Error", "An unexpected error has occurred.", "error");
      }
    } finally {
      dispatch(triggerLoader());
    }
  };

  // Row-level order search: uses the clicked row's item only, trims other rows
  // on success, and locks further searches until reset.
  const handleSearchAgainstOrderForRow = async (rowId) => {
    try {
      const customer_id = invoice.customer_id;
      const rowItem = itemList.find((it) => it.id === rowId);
      const itemid = rowItem?.item_id;

      if (!customer_id) {
        handleOpenDialog("Warning", "Please select a firm first.", "warning");
        return;
      }
      if (!itemid) {
        handleOpenDialog(
          "Warning",
          "Please pick an item in the row first.",
          "warning"
        );
        return;
      }

      dispatch(triggerLoader());
      const res = await configServ.getLatestOrderByItemCustomer({
        customer_id,
        itemid,
      });

      if (res.status === 200 && res.data) {
        const order = res.data;
        if (!hasOrderPoNumber(order)) {
          handleOpenDialog(
            "Warning",
            getMissingPoNumberMessage(order),
            "warning"
          );
          return;
        }
        setInvoice((prev) => ({
          ...prev,
          contact_name: order.partyname || prev.contact_name,
          buyeraddress: order.billtoaddress || prev.buyeraddress,
          ShipToAddress: order.shiptoaddress || prev.ShipToAddress,
          salesperson: order.salesperson || prev.salesperson,
          customer_id: order.customer_id || prev.customer_id,
          sales_order: order.po_number || prev.sales_order,
          order_id: order.id,
        }));
        setAgainstOrder({
          order_id: order.id,
          order_no: order.order_no,
          allowed_item_ids: (order.order_items || []).map((oi) => oi.itemid),
        });
        setItemList([{ ...rowItem, id: 1 }]);
        setItemListError([]);
        setIsRowOrderSearchLocked(true);
        setInputOrderNo(order.po_number);
        handleOpenDialog(
          "Success",
          `Linked to order ${order.order_no || "#" + order.id}.`,
          "success"
        );
      } else if (res.status === 404) {
        handleOpenDialog(
          "Info",
          res.message || "No matching order found.",
          "info"
        );
      } else if (res.status === 422) {
        handleOpenDialog(
          "Warning",
          res.message || "Validation failed.",
          "warning"
        );
      } else {
        handleOpenDialog(
          "Error",
          res.message || "Failed to load order.",
          "error"
        );
      }
    } catch (e) {
      console.log(e);
      const error = e?.response?.data;
      if (error?.status === 404) {
        handleOpenDialog("Not Found", "Order not found.", "warning");
      } else {
        handleOpenDialog("Error", "An unexpected error has occurred.", "error");
      }
    } finally {
      dispatch(triggerLoader());
    }
  };

  // Clear the order link — the form returns to the normal (unrestricted) flow.
  const clearAgainstOrder = () => {
    setAgainstOrder(null);
  };

  // ----- New: submit when an order is linked. Same shape as handleSubmit but
  // calls /api/create-invoice-against-order and adds order_id to the payload.
  const handleSubmitAgainstOrder = async () => {
    try {
      dispatch(triggerLoader());
      const invoiceErrors = validateInvoice();
      const itemListErrors = validateItemList();
      if (
        Object.keys(invoiceErrors).length > 0 ||
        Object.keys(itemListErrors).length > 0
      ) {
        return false;
      }

      invoice.is_credit_limit = is_credit_limit;
      invoice.item = await handleInvoiceItemList();

      const dataToSend = {
        ...invoice,
        user_id: user_id,
        company_id: company_id,
        with_gst: withGST,
        isManualCreated: isManualCreated,
        manual_order_no: isManualCreated ? manualOrderNo : null,
        order_id: againstOrder.order_id,
      };

      const res = await configServ.createInvoiceAgainstOrder(dataToSend);
      if (res.status === 200 || res.status === 201) {
        handleReset();
        setAgainstOrder(null);
        setOpen(true);
        const resData = res.data;
        const printInvData = { ...resData, user_id: user_id };
        setInvoiceData(printInvData);
        setIsCreate(!isCreate);
        setIsChanged(!isChanged);
      } else if (res.status === 409) {
        setConfirmationMessage(res.message);
      } else if (res.status === 404) {
        handleOpenDialog(
          "Error",
          res.message || "Order not found.",
          "error"
        );
      } else if (res.status === 422) {
        let msg = res.message || "Validation failed.";
        if (Array.isArray(res.invalid_item_ids) && res.invalid_item_ids.length) {
          msg += ` Invalid items: ${res.invalid_item_ids.join(", ")}`;
        }
        handleOpenDialog("Error", msg, "error");
      } else {
        handleOpenDialog(
          "Error",
          res.message || "Invoice creation failed. Please try again.",
          "error"
        );
      }
    } catch (e) {
      console.log(e);
      handleOpenDialog("Error", "An unexpected error has occurred.", "error");
    } finally {
      dispatch(triggerLoader());
    }
  };

  const handlePopup = () => {
    try {
      if (isCreate === true) {
        handleReset();
      }
      setIsCreate(!isCreate);
      dispatch(rSetShowFab(isCreate));
    } catch (e) {
      console.log(e);
    }
  };

  const checkInvoiceNumber = async () => {
    try {
      const dataToSend = {
        company_id: company_id,
        invoice_number: invoice.invoice_number,
      };
      const res = await configServ.checkInvoiceNumber(dataToSend);
      if (res.status === 200) {
        setIsInvoiceNumber(true);
      } else {
        setIsInvoiceNumber(false);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (invoice.invoice_number) {
      checkInvoiceNumber();
    } else {
      setIsInvoiceNumber(true);
    }
  }, [invoice.invoice_number]);

  const handleConfirm = async (response) => {
    if (response === true) {
      setIs_credit_limit(false);
    } else {
      setIs_credit_limit(true);
    }
  };

  useEffect(() => {
    if (is_credit_limit === false) {
      handleSubmit();
    }
  }, [is_credit_limit]);

  const handleCustomerOpen = () => {
    try {
      setOpenDirectCustomer(true);
    } catch (e) {
      console.log(e);
    }
  };

  const handleCustomerClose = () => {
    try {
      fetchCustomerList();
      setOpenDirectCustomer(false);
    } catch (e) {
      console.log(e);
    }
  };
  const handleCut = () => {
    setIsCreate(!isCreate);
    handleReset();
  };

  // sales order no setting

  const fetchOrderNo = async () => {
    try {
      const dataToSend = {
        company_id: company_id,
        customer_id: invoice.customer_id,
      };
      const res = await configServ.getFilteredOrders(dataToSend);
      if (res.status) {
        setOrderNo(res.data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if ((isCreate, company_id, invoice.customer_id)) {
      fetchOrderNo();
    }
  }, [isCreate, company_id, invoice.customer_id]);

  useEffect(() => {
    if (isManualCreated || !invoice.order_id || orderNo.length === 0) return;
    const linked = orderNo.find((o) => o.id === invoice.order_id);
    if (linked && hasOrderPoNumber(linked)) {
      setInputOrderNo(linked.po_number);
    }
  }, [orderNo, invoice.order_id, isManualCreated]);

  const handleOrderSelect = (selectedOrderNo) => {
    const selectedOrder = orderNo.find((o) => o.order_no === selectedOrderNo);
    if (!selectedOrder) return;

    if (!hasOrderPoNumber(selectedOrder)) {
      handleOpenDialog(
        "Warning",
        getMissingPoNumberMessage(selectedOrder),
        "warning"
      );
      setInputOrderNo(
        isManualCreated ? manualOrderNo : invoice.sales_order || ""
      );
      return;
    }

    // set local GST flag — always force With GST on for invoices
    const isGSTEnabled = true;
    setWithGST(true);

    const inv = {
      // contact_name: selectedOrder.partyname,
      // printID: "",
      // buyeraddress: selectedOrder.billtoaddress,
      // ShipToAddress: selectedOrder.shiptoaddress,
      // auto_gen: "on",
      // date: Calculation.GetCurrentDate(),
      // due_date: Calculation.getCurrentDatePlusDays(30),
      order_id: selectedOrder.id,
      sales_order: selectedOrder.po_number,
      // salesperson: selectedOrder.salesperson,
      // pay_mode: "",
      // customer_id: selectedOrder.customer_id,
    };

    setInvoice((prev) => ({
      ...prev, // 👈 preserve editData fields like id, created_by etc.
      ...inv, // 👈 override with selected sales order fields
    }));

    const itemlist = selectedOrder.items.map((item, index) => ({
      id: index + 1,
      itemname: item.itemname,
      item_id: item.itemid,
      itemcode: item.item_code,
      packagingunit: "",
      hsn_code: item.hsn_code,
      tax_rate: isGSTEnabled ? parseFloat(item.Taxrate) : 0,
      qty: item.qty,
      unit: item.unit,
      rate: item.billable_rate,
      amountWithoutTax: item.tax_amount
        ? item.amount - parseFloat(item.tax_amount)
        : item.amount,
      discount: item.discount,
      tax_amount: item.tax_amount ? parseFloat(item.tax_amount) : 0,
      amount: parseFloat(item.amount),
      remarks: "",
      issizeAdded: item.issizeAdded,
    }));

    setItemList(itemlist);
    fetchShipToAddress(selectedOrder.customer_id);
    setInputOrderNo(selectedOrder.po_number);
  };

  const highlightMatch = (text, query) => {
    try {
      const words = query.toLowerCase().split(" ").filter(Boolean);
      const regex = new RegExp(`(${words.join("|")})`, "gi");

      return text.split(regex).map((part, index) =>
        words.includes(part.toLowerCase()) ? (
          <mark key={index} style={{ backgroundColor: "#ffe58f" }}>
            {part}
          </mark>
        ) : (
          <React.Fragment key={index}>{part}</React.Fragment>
        )
      );
    } catch (e) {
      console.error("Error in highlightMatch:", e);
      return text;
    }
  };

  //#endregion

  return (
    <>
      <AlertDialog
        open={dialogOpen}
        setOpen={handleCloseDialog}
        title={title}
        message={dialogContent}
        buttonTitle="Ok"
        buttonType={buttonType}
      />

      <WantToPrint open={open} setOpen={setOpen} data={invoiceData} />

      <ConfirmationDialog
        message={confirmationMessage}
        onClose={() => setConfirmationMessage(null)}
        onConfirm={handleConfirm}
      />

      <CardHeadMenu
        prefix={"Inv"}
        suffix={"Order"}
        title={"INVOICE"}
        handlePopup={handlePopup}
        isEdit={isEdit}
        handleOTI={handleOTI}
        create={isCreate}
        showCreate={Boolean(is_super || is_admin || permissions?.includes(3))}
      />

      <OrderToInvoice
        handleClose={handleOTI}
        open={oti}
        sendData={setInvoice}
        sendItems={setItemList}
        invoiceInitial={invoiceInitial}
        itemListInitial={itemListInitial}
      />

      <CustomerDirectCashPopUp
        open={openDirectCustomer}
        close={handleCustomerClose}
      />

      {isCreate === true && (
        <>
          <motion.div
            style={{
              width: "100%",
              backgroundColor: "#e3f3fc",
              padding: 20,
              paddingLeft: 0,
              borderRadius: "10px",
              border: "none",
              margin: "10px",
            }}
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.1, delay: 0.1 }}
          >
            <Grid
              container
              alignItems="flex-end"
              justifyContent="flex-start"
              style={{ padding: 10 }}
              spacing={1}
            >
              <Grid item xs={6} md={6}>
                {/* <Link to="/account-master-entry/customers">
                  <Tooltip title={"Add customer"}>
                    <PersonAddIcon
                      sx={{
                        cursor: "pointer",
                        color: "white",
                        backgroundColor: "grey",
                        margin: "2px",
                      }}
                      justifyContent="flex-end"
                    />
                  </Tooltip>
                </Link> */}
              </Grid>
              <Grid
                container
                item
                xs={6}
                md={6}
                alignItems={"center"}
                justifyContent={"flex-end"}
              >
                <Stack direction={"row"} spacing={1} alignItems="center">
                  {isEdit ? (
                    <>
                      <IconButton
                        onClick={handleCut}
                        sx={{
                          borderRadius: 2,
                          px: 2,
                          py: 1,
                          backgroundColor: "red",
                          color: "white",
                          "&:hover": {
                            backgroundColor: "darkred",
                          },
                          boxShadow: 2,
                          ml: 1,
                          transition: "all 0.3s ease",
                        }}
                        title="Close"
                      >
                        <CancelIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </>
                  ) : (
                    <>
                      <IconButton
                        onClick={handleReset}
                        sx={{
                          borderRadius: 2,
                          px: 2,
                          py: 1,
                          backgroundColor: "secondary.main",
                          color: "white",
                          "&:hover": {
                            backgroundColor: "secondary.dark",
                          },
                          ml: 1,
                        }}
                        title="Reset"
                      >
                        <RotateLeftIcon sx={{ fontSize: 16 }} />
                      </IconButton>
                    </>
                  )}

                  <IconButton
                    size="small"
                    onClick={handleSubmit}
                    sx={{
                      borderRadius: 2,
                      px: 2,
                      py: 1,
                      backgroundColor: isEdit ? "success.main" : "primary.main",
                      color: "white",
                      "&:hover": {
                        backgroundColor: isEdit
                          ? "success.dark"
                          : "primary.dark",
                      },
                    }}
                    title={isEdit ? "Update" : "Save"}
                  >
                    <SaveIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Stack>
              </Grid>

              <Grid item xs={12} md={3}>
                <Autocomplete
                  disablePortal
                  fullWidth
                  size="small"
                  id="customer_id"
                  name="customer_id"
                  options={customers}
                  getOptionLabel={(option) => option.fname}
                  filterOptions={(options, { inputValue }) => {
                    const words = inputValue
                      .toLowerCase()
                      .split(" ")
                      .filter(Boolean);

                    return options.filter((customer) =>
                      words.every(
                        (word) =>
                          customer.fname.toLowerCase().includes(word) ||
                          (customer.mobile && customer.mobile.includes(word))
                      )
                    );
                  }}
                  sx={{ background: "white" }}
                  value={
                    customers.find(
                      (customer) => customer.id === invoice.customer_id
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    if (newValue) {
                      handleCustomerAutocompleteChange(
                        "customer_id",
                        newValue.id
                      );
                    }
                  }}
                  renderInput={(params) => {
                    const inputValue = params.inputProps.value || "";
                    const doesNotMatchOption =
                      inputValue &&
                      !customers.some((customer) =>
                        inputValue
                          .toLowerCase()
                          .split(" ")
                          .filter(Boolean)
                          .every(
                            (word) =>
                              customer.fname.toLowerCase().includes(word) ||
                              (customer.mobile &&
                                customer.mobile.includes(word))
                          )
                      );

                    return (
                      <Box display="flex" alignItems="center" width="100%">
                        <TextField
                          {...params}
                          label="Firm Name"
                          name="customer_id"
                          onChange={handleCustomerInputChange}
                          error={!!invoiceError.customer_id}
                          fullWidth
                        />
                        {doesNotMatchOption && (
                          <IconButton
                            color="primary"
                            onClick={handleCustomerOpen}
                          >
                            <AddCircleIcon />
                          </IconButton>
                        )}
                      </Box>
                    );
                  }}
                  renderOption={(props, option, { inputValue }) => (
                    <li {...props}>
                      <Box display="flex" flexDirection="column">
                        <Typography variant="body2">
                          {highlightMatch(option?.fname, inputValue)}
                        </Typography>
                        {option?.mobile && (
                          <Typography variant="caption" color="text.secondary">
                            {highlightMatch(option?.mobile, inputValue)}
                          </Typography>
                        )}
                      </Box>
                    </li>
                  )}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  name="buyeraddress"
                  value={invoice.buyeraddress}
                  onChange={handleInvoiceCustomer}
                  label="Bill To Address"
                  fullWidth
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  error={!!invoiceError.buyeraddress}
                  InputLabelProps={{
                    shrink: invoice.buyeraddress ? true : false,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Autocomplete
                  freeSolo
                  disablePortal
                  fullWidth
                  size="small"
                  id="ShipToAddress"
                  options={shipToAddresses}
                  getOptionLabel={(option) =>
                    typeof option === "string" ? option : option.address || ""
                  }
                  filterOptions={(options, { inputValue }) => {
                    const words = inputValue
                      .toLowerCase()
                      .split(" ")
                      .filter(Boolean);
                    return options.filter((addr) =>
                      words.every((word) =>
                        addr.address.toLowerCase().includes(word)
                      )
                    );
                  }}
                  sx={{ backgroundColor: "white" }}
                  value={
                    invoice.manualShipAddress
                      ? invoice.ShipToAddress // manual address typed
                      : shipToAddresses.find(
                          (addr) => addr.address === invoice.ShipToAddress
                        ) || null
                  }
                  inputValue={invoice.ShipToAddress || ""}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      // jab user type kare
                      const matched = shipToAddresses.find(
                        (addr) => addr.address === newInputValue
                      );

                      if (!matched && newInputValue) {
                        // 🔹 Manual address
                        handleInvoiceCustomer({
                          target: {
                            name: "ShipToAddress",
                            value: newInputValue,
                          },
                        });
                        setInvoice((prev) => ({
                          ...prev,
                          ShipToAddress: newInputValue,
                          manualShipAddress: true,
                        }));
                      } else if (!newInputValue) {
                        // 🔹 Input clear
                        setInvoice((prev) => ({
                          ...prev,
                          ShipToAddress: "",
                          manualShipAddress: false,
                        }));
                      }
                    }
                  }}
                  onChange={(event, newValue) => {
                    if (typeof newValue === "string") {
                      // 🔹 User typed custom address
                      handleInvoiceCustomer({
                        target: { name: "ShipToAddress", value: newValue },
                      });
                      setInvoice((prev) => ({
                        ...prev,
                        ShipToAddress: newValue,
                        manualShipAddress: true,
                      }));
                    } else if (newValue && newValue.address) {
                      // 🔹 User selected from dropdown
                      handleInvoiceCustomer({
                        target: {
                          name: "ShipToAddress",
                          value: newValue.address,
                        },
                      });
                      setInvoice((prev) => ({
                        ...prev,
                        ShipToAddress: newValue.address,
                        manualShipAddress: false,
                      }));
                    } else {
                      // 🔹 Clear
                      setInvoice((prev) => ({
                        ...prev,
                        ShipToAddress: "",
                        manualShipAddress: false,
                      }));
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        invoice.manualShipAddress
                          ? "Manual Ship To Address"
                          : "Ship To Address"
                      }
                      name="ShipToAddress"
                      error={!!invoiceError?.ShipToAddress}
                      fullWidth
                    />
                  )}
                  renderOption={(props, option, { inputValue }) => (
                    <li {...props}>
                      <Typography variant="body2">
                        {highlightMatch(option.address, inputValue)}
                      </Typography>
                    </li>
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.address === value ||
                    option.address === value?.address
                  }
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  type="date"
                  label="Invoice Date"
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="date"
                  value={invoice.date}
                  onChange={handleInvoiceCustomer}
                  InputLabelProps={{ shrink: true }}
                  sx={{ backgroundColor: "white" }}
                  error={!!invoiceError.date}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  type="date"
                  label="Invoice Due Date"
                  name="due_date"
                  value={invoice.due_date}
                  onChange={handleInvoiceCustomer}
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  error={!!invoiceError.due_date}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Autocomplete
                  freeSolo
                  disabled={isRowOrderSearchLocked}
                  options={orderNo}
                  getOptionLabel={(option) =>
                    typeof option === "string"
                      ? option
                      : hasOrderPoNumber(option)
                      ? option.po_number
                      : option.order_no
                  }
                  filterOptions={(options, { inputValue }) => {
                    const words = inputValue
                      .toLowerCase()
                      .split(" ")
                      .filter(Boolean);
                    return options.filter((opt) => {
                      const orderNoText = (opt.order_no || "").toLowerCase();
                      const poNumberText = (opt.po_number || "").toLowerCase();
                      return words.every(
                        (word) =>
                          orderNoText.includes(word) ||
                          poNumberText.includes(word)
                      );
                    });
                  }}
                  value={
                    isManualCreated
                      ? manualOrderNo
                      : invoice.order_id
                      ? orderNo.find((o) => o.id === invoice.order_id) ||
                        invoice.sales_order ||
                        ""
                      : invoice.sales_order || ""
                  }
                  inputValue={inputOrderNo}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "reset") return;
                    setInputOrderNo(newInputValue);

                    const matched = orderNo.find(
                      (o) =>
                        o.order_no === newInputValue ||
                        (o.po_number &&
                          String(o.po_number).trim() ===
                            String(newInputValue).trim())
                    );
                    if (!matched && newInputValue) {
                      setIsManualCreated(true);
                      setManualOrderNo(newInputValue);
                      setInvoice((prev) => ({
                        ...prev,
                        sales_order: "",
                        order_id: null,
                      }));
                    } else if (!newInputValue) {
                      setIsManualCreated(false);
                      setManualOrderNo("");
                      setInvoice((prev) => ({
                        ...prev,
                        sales_order: "",
                        order_id: null,
                      }));
                    }
                  }}
                  onChange={(event, newValue) => {
                    if (typeof newValue === "string") {
                      setIsManualCreated(true);
                      setManualOrderNo(newValue);
                      setInvoice((prev) => ({
                        ...prev,
                        sales_order: newValue,
                        order_id: null,
                      }));
                    } else if (newValue && newValue.order_no) {
                      if (!hasOrderPoNumber(newValue)) {
                        handleOpenDialog(
                          "Warning",
                          getMissingPoNumberMessage(newValue),
                          "warning"
                        );
                        setInputOrderNo(
                          isManualCreated
                            ? manualOrderNo
                            : invoice.sales_order || ""
                        );
                        return;
                      }
                      setIsManualCreated(false);
                      setManualOrderNo("");
                      handleOrderSelect(newValue.order_no);
                    } else {
                      setIsManualCreated(false);
                      setManualOrderNo("");
                      setInputOrderNo("");
                      setInvoice((prev) => ({
                        ...prev,
                        sales_order: "",
                        order_id: null,
                      }));
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        isManualCreated
                          ? "Manual Customer PO No"
                          : "Customer PO No"
                      }
                      size="small"
                      fullWidth
                      sx={{ backgroundColor: "white" }}
                    />
                  )}
                  renderOption={(props, option, { inputValue }) => (
                    <li {...props}>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                        gap={1}
                      >
                        <Typography variant="body2" sx={{ flex: 1 }}>
                          {highlightMatch(option.order_no || "", inputValue)}
                        </Typography>
                        <Box
                          display="flex"
                          alignItems="center"
                          gap={0.5}
                          sx={{ flexShrink: 0 }}
                        >
                          <ArrowForwardIcon
                            sx={{ fontSize: 16, color: "gray" }}
                          />
                          <Typography variant="body2" color="text.secondary">
                            {hasOrderPoNumber(option)
                              ? highlightMatch(option.po_number, inputValue)
                              : "—"}
                          </Typography>
                        </Box>
                      </Box>
                    </li>
                  )}
                  isOptionEqualToValue={(option, value) =>
                    typeof value === "string"
                      ? option.order_no === value ||
                        option.po_number === value
                      : option.id === value?.id
                  }
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <Autocomplete
                  freeSolo
                  options={staffList.map((c) => c.fname)} // Dropdown only staff names
                  inputValue={inputValue}
                  onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);
                    handleInvoiceCustomer({
                      target: { name: "salesperson", value: newInputValue },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Salesperson/Ref. Name"
                      variant="outlined"
                      fullWidth
                      size="small"
                      sx={{ backgroundColor: "white" }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl
                  fullWidth
                  size="small"
                  variant="outlined"
                  sx={{ backgroundColor: "white" }}
                >
                  <InputLabel id="pay_mode-label">Payment Mode</InputLabel>
                  <Select
                    labelId="pay_mode-label"
                    id="pay_mode"
                    name="pay_mode"
                    value={invoice.pay_mode || ""}
                    onChange={handleInvoiceCustomer}
                    label="Payment Mode"
                  >
                    <MenuItem value="Weekly">Weekly</MenuItem>
                    <MenuItem value="Monthly">Monthly</MenuItem>
                    <MenuItem value="One-Time">One-Time</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  disabled={isEdit}
                  label="Invoice No"
                  variant="outlined"
                  name="invoice_number"
                  value={invoice.invoice_number}
                  onChange={handleInvoiceCustomer}
                  type="text"
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: invoice.invoice_number ? true : false,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {isInvoiceNumber || isEdit ? (
                          <CheckCircleIcon color="success" />
                        ) : (
                          <CancelIcon color="error" />
                        )}
                      </InputAdornment>
                    ),
                  }}
                  sx={{ backgroundColor: "white" }}
                  error={!!invoiceError.invoice_number}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label="TCS(%)"
                  variant="outlined"
                  name="tcs_rate"
                  value={invoice.tcs_rate}
                  onChange={handleInvoiceCustomer}
                  type="text"
                  fullWidth
                  size="small"
                  sx={{ backgroundColor: "white" }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label="Delivery Note"
                  name="delivery_note"
                  value={invoice.delivery_note}
                  onChange={handleInvoiceCustomer}
                  variant="outlined"
                  fullWidth
                  size="small"
                  multiline
                  rows={2}
                  sx={{ backgroundColor: "white" }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    borderRadius: "5px",
                    backgroundColor: "white",
                    boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.3)",
                  }}
                >
                  <FormControl component="fieldset">
                    <FormLabel
                      component="legend"
                      sx={{ fontWeight: "bolder", marginLeft: "20px" }}
                    >
                      Tax in
                    </FormLabel>
                    <RadioGroup
                      name="use-radio-group"
                      row
                      sx={{ marginLeft: "20px" }}
                    >
                      <FormControlLabel
                        checked={withGST && invoice.tax_type === "CGST+SGST"}
                        value="CGST_SGST"
                        label="CGST + SGST"
                        control={
                          <Radio
                            size="small"
                            disabled={!withGST}
                            onClick={() =>
                              setInvoice((prev) => ({
                                ...prev,
                                tax_type: "CGST+SGST",
                              }))
                            }
                          />
                        }
                      />
                      <FormControlLabel
                        checked={withGST && invoice.tax_type === "IGST"}
                        value="IGST"
                        label="IGST"
                        control={
                          <Radio
                            size="small"
                            disabled={!withGST}
                            onClick={() =>
                              setInvoice((prev) => ({
                                ...prev,
                                tax_type: "IGST",
                              }))
                            }
                          />
                        }
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Grid>
            </Grid>

            <AddInvoiceItems
              itemList={itemList}
              handleAutocompleteChange={handleAutocompleteChange}
              handleInputChange={handleInputChange}
              handleAddItem={handleAddItem}
              handleDeleteItem={handleDeleteItem}
              items={items}
              handleQuantityChange={handleQuantityChange}
              handleDiscountChange={handleDiscountChange}
              handleRemarksChange={handleRemarksChange}
              errors={itemListError}
              withGST={withGST}
              handleRowOrderSearch={handleSearchAgainstOrderForRow}
              isOrderSearchLocked={isRowOrderSearchLocked}
              isFirmSelected={Boolean(invoice.customer_id)}
              allowedItemIds={againstOrder?.allowed_item_ids || null}
              againstOrder={againstOrder}
              clearAgainstOrder={clearAgainstOrder}
            />

            <Grid container alignItems={"center"} spacing={1}>
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ marginTop: "10px", color: "green" }}
                >
                  Quantity: {totalQuantity}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ marginTop: "10px", color: "green" }}
                >
                  Tax Amount: ₹{CheckAndReturn.roundToInteger(totalTaxAmount)}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ marginTop: "10px", color: "green" }}
                >
                  Gross Amount: ₹{CheckAndReturn.roundToInteger(totalAmount)}
                </Typography>
              </Grid>

              {is_coupan && (
                <>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ marginTop: "10px", color: "green" }}
                    >
                      Coupon Code: {coupon_code || "N/A"}
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ marginTop: "10px", color: "green" }}
                    >
                      Coupon Discount: ₹{coupon_discount || 0}
                    </Typography>
                  </Grid>
                </>
              )}

              <Grid
                container
                item
                xs={12}
                md={12}
                alignItems={"center"}
                justifyContent={"flex-end"}
              >
                <Stack direction={"row"} spacing={1}>
                  <IconButton
                    size="small"
                    onClick={handleSubmit}
                    sx={{
                      borderRadius: 2,
                      px: 2,
                      py: 1,
                      backgroundColor: isEdit ? "success.main" : "primary.main",
                      color: "white",
                      "&:hover": {
                        backgroundColor: isEdit
                          ? "success.dark"
                          : "primary.dark",
                      },
                    }}
                    title={isEdit ? "Update" : "Save"}
                  >
                    <SaveIcon sx={{ fontSize: 22 }} />
                  </IconButton>
                </Stack>
              </Grid>
            </Grid>
          </motion.div>
        </>
      )}
    </>
  );
}

export default memo(InvoiceCard);
